import Path from 'assets/icons/base/Path';
import PropTypes from 'prop-types';
import React from 'react';
import Rect from './base/Rect';
import SVG from 'assets/icons/base/SVG';
import colors from 'config/theme/colors';

const Play = ({ color = colors.black, height = '79px', width = '79px', viewBox = '0 0 81 80', ...rest }) => (
    <SVG height={height} viewBox={viewBox} width={width} fill="none" {...rest}>
        <Rect x="1" y=".5" height={height} width={width} rx="39.5" stroke={color} />
        <Path d="m56.5 40-24-16v32l24-16Z" fill={color} />
    </SVG>
);

Play.propTypes = {
    color: PropTypes.string,
    height: PropTypes.string,
    viewBox: PropTypes.string,
    width: PropTypes.string,
};

export default Play;
